import UppyFactory from '../../../../factory/uppy';

const DesignFacade = require('../../../../facade/design/design');
const RestrictionsFactory = require('../../../../factory/restrictions');

const BaseView = require('./abstract-type');

module.exports = BaseView.extend({
  type: 'logo',
  template: require('./logo-type.hbs'),
  ElementListView: require('./element-list/logos-view'),
  basicHide: ['logo_add', 'logo_replace', 'logo_position', 'logo_colour', 'logo_stroke', 'logo_z_index'],
  events: _.extend({
    'slide .slider': 'slideEvent',
    'click ui-slider-handle': 'resizeMarginEvent',
    'keydown input[name="size"]': 'preventNonNumericInput',
    'keyup input[name="size"]': 'resizeMarginEvent',
    'change input[name="size"]': 'resizeMarginEvent',
    'change input[name="vertical"]': 'verticalMoveEvent',
    'change input[name="horizontal"]': 'horizontalMoveEvent'
  }, BaseView.prototype.events),

  selectSpecifyFolder: function () {
    document.querySelector('#element-restrictions-source').checked = false;
    document.querySelector('#element-restrictions-folder').checked = true;
    const sourceList = this.el.querySelector('.logo-replacement-options');
    const folderList = this.el.querySelector('.logo-replacement-folders');
    sourceList.classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', false);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-folder'));
  },

  selectSpecifySource: function () {
    document.querySelector('#element-restrictions-folder').checked = false;
    document.querySelector('#element-restrictions-source').checked = true;
    const sourceList = this.el.querySelector('.logo-replacement-options');
    const folderList = this.el.querySelector('.logo-replacement-folders');
    sourceList.classList.toggle('hidden', false);
    folderList.classList.toggle('hidden', true);
    this.initAddButton();
    this.logosListView.addElement(this.selection.source);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-folder'));
  },

  toggleSectionEvent: function (event) {
    const input = event.currentTarget;
    const sectionName = input.closest('.restrictions.group').getAttribute('data-name');

    if (input.checked) {
      this._renderImageAndColorSubsection(input);
    } else {
      sectionName === 'margin' && $('#margin-box').remove();
      sectionName === 'movement' && $('#horizontal-line, #vertical-line').remove();
    }

    if (sectionName === 'folder') {
      this.selectSpecifyFolder();
    }

    if (sectionName === 'source') {
      this.selectSpecifySource();
    }

    this._toggleSectionDisabled(input);
    this.recalculateSectionHeight(input);

    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  _renderImageAndColorSubsection: function (input) {
    if (input.id === 'element-restrictions-colors' && !this.colorsListView.getData().length) {
      const shapes = this.selection.shapes;
      const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');
      this._addColorToColorLibrary(shapes);
      colorsLibrary.checked = false;
      this._toggleSectionDisabled(colorsLibrary);
      this.onSectionChange(colorsLibrary);
    } else if (input.id === 'element-restrictions-colors-library') {
      const colors = this.el.querySelector('#element-restrictions-colors');

      this.colorsLibraryView.setLibraryPaletteRestriction({ palette: 0 });
      colors.checked = false;
      this._toggleSectionDisabled(colors);
      this.onSectionChange(colors);
    } else if (input.id === 'element-restrictions-source' && !this.logosListView.getData().length) {
      this.logosListView.addElement({
        thumb_src: this.selection.thumb_src,
        is_vector: this.selection.is_vector
      });
    }
  },

  _addColorToColorLibrary: function (shapes) {
    if (shapes) {
      for (const [key, shape] of Object.entries(shapes)) {
        const color = shape.fill.color;
        color && this.colorsListView.addElement(color);
      }
    } else {
      const color = this.selection.fill.color;
      color && this.colorsListView.addElement(color);
    }
  },

  _toggleSectionDisabled: function (option) {
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    sectionName === 'basic'
      ? this._toggleBasicSectionDisabled(name, value)
      : this._toggleOtherSectionDisabled(sectionName, value);
  },

  _toggleBasicSectionDisabled: function (name, value) {
    name === `${this.type}_replace` && this._toggleReplace(value);
    name === `${this.type}_position` && this._togglePosition(value);
    name === 'color' && this._toggleColors(value);
  },

  _toggleReplace: function (value) {
    const logosSection = this.el.querySelector('div[data-name="source"]');
    const logosFolderSection = this.el.querySelector('div[data-name="folder"]');
    const specialLogosInput = logosSection.querySelector('#element-restrictions-source');
    const specialLogosFolder = logosFolderSection?.querySelector('#element-restrictions-folder');

    logosSection.classList.toggle('hidden', !value);
    logosFolderSection?.classList.toggle('hidden', !value);

    specialLogosInput.classList.toggle('hidden', !value);
    specialLogosFolder?.classList.toggle('hidden', !value);

    if (value) {
      this.initAddButton();
      return;
    }

    if (specialLogosInput.checked) {
      this.el.querySelector(`.${this.type}-replacement-options`).classList.toggle('hidden', true);
      specialLogosInput.checked = false;
      this.logosListView.removeAllElement();
      this.onSectionChange(specialLogosInput);
    }

    if (specialLogosFolder?.checked) {
      specialLogosFolder.checked = false;
      this.el.querySelector(`.${this.type}-replacement-folders`).classList.toggle('hidden', true);
    }
  },

  _togglePosition: function (value) {
    const margin = this.el.querySelector('div[data-name="margin"]');
    const movement = this.el.querySelector('div[data-name="movement"]');
    const marginInput = margin.querySelector('#element-restrictions-margin');
    const movementInput = movement.querySelector('#element-restrictions-movement');

    margin.classList.toggle('hidden', !value);
    movement.classList.toggle('hidden', !value);

    if (value) return;

    if (marginInput.checked) {
      this.el.querySelector('.margin-replacement-options').classList.toggle('hidden', true);
      marginInput.checked = false;
      this.onSectionChange(marginInput);
    }

    if (movementInput.checked) {
      this.el.querySelector('.movement-replacement-options').classList.toggle('hidden', true);
      movementInput.checked = false;
      this.onSectionChange(movementInput);
    }
  },

  _toggleColors: function (value) {
    const colors = this.el.querySelector('#element-restrictions-colors');
    const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

    this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !value);
    this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !value);

    if (value) return;

    if (colors.checked) {
      this.el.querySelector('.color-replacement-options').classList.toggle('hidden', true);
      colors.checked = false;
      this.onSectionChange(colors);
    }

    if (colorsLibrary.checked) {
      this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', true);
      colorsLibrary.checked = false;
      this.colorsListView.removeAllElement();
      this.onSectionChange(colorsLibrary);
    }
  },

  _toggleOtherSectionDisabled: function (sectionName, value) {
    if (sectionName === 'source') {
      this.selectSpecifySource();
    } else if (sectionName === 'margin') {
      this.el.querySelector('.margin-replacement-options').classList.toggle('hidden', !value);
    } else if (sectionName === 'movement') {
      this.el.querySelector('.movement-replacement-options').classList.toggle('hidden', !value);
    } else if (sectionName === 'colors') {
      this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !value);
      !value && this.colorsListView.removeAllElement();
    } else if (sectionName === 'colors-library') {
      this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !value);
    } else if (sectionName === 'folder') {
      this.selectSpecifyFolder();
    }
  },

  slideEvent: function (event, ui) {
    const $option = this.$el.find('input[name="size"]');
    $option.val(ui.value);
    this.setMarginUI(ui.value);
    this.persistOptionRestriction($option);
  },

  preventNonNumericInput: function (event) {
    if (event.key === '+' || event.key === '-' || event.key === 'e') {
      event.preventDefault();
    }
  },

  resizeMarginEvent: function (event) {
    const $option = $(event.currentTarget);
    let val = parseFloat($option.val());
    const maxMargin = this.getMaxMargin();

    if (val > maxMargin) {
      val = maxMargin;
      $option.val(val);
    }

    if (val >= 0) {
      this.marginSlider.slider('value', val);
      this.setMarginUI(val);
      this.persistOptionRestriction($option);

      if ($option.val().length > $option.attr('max').length) {
        this.marginSlider.slider('value', 0);
        this.setMarginUI(0);
        $option.val(0);
      }
    }
  },

  setMarginUI: function (margin) {
    const dim = svgedit.utilities.getBBox($('#selectedBox0')[0]);
    const marginBox = document.createElementNS(svgedit.NS.SVG, 'rect');

    $('#margin-box').remove();
    this.canvas.assignAttributes(marginBox, {
      id: 'margin-box',
      width: dim.width + margin,
      height: dim.height + margin,
      x: dim.x - (margin / 2),
      y: dim.y - (margin / 2),
      'stroke-width': margin,
      fill: 'none',
      'stroke-opacity': 0.3,
      stroke: '#ED3636'
    });

    const selector = $('#selectorGroup0')[0];
    selector.insertBefore(marginBox, selector.firstChild);
  },

  horizontalMoveEvent: function (event) {
    this.setMoveUI('horizontal', $(event.currentTarget).is(':checked'));
  },

  verticalMoveEvent: function (event) {
    this.setMoveUI('vertical', $(event.currentTarget).is(':checked'));
  },

  setMoveUI: function (mode, enabled) {
    const dim = svgedit.utilities.getBBox($('#selectedBox0')[0]);
    const line = document.createElementNS(svgedit.NS.SVG, 'line');
    const isVertical = mode === 'vertical';

    $('#' + mode + '-line').remove();
    this.canvas.assignAttributes(line, {
      id: mode + '-line',
      x1: isVertical ? dim.x + dim.width / 2 : dim.x,
      y1: isVertical ? dim.y : dim.y + dim.height / 2,
      x2: isVertical ? dim.x + dim.width / 2 : dim.x + dim.width,
      y2: isVertical ? dim.y + dim.height : dim.y + dim.height / 2,
      'stroke-width': 2,
      'stroke-dasharray': 5,
      stroke: enabled ? '#01ADB6' : '#ED3636'
    });

    const elementBox = document.getElementById('selectorGroup0');
    elementBox.appendChild(line);
  },

  initialize: function () {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
    BaseView.prototype.initialize.apply(this, arguments);
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list') && $option.data('uuid') === 'color') {
      return this.colorsListView.getData();
    }

    if ($option.is('.element-list')) return this.logosListView.getData();
    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  render: async function () {
    const someGroup = _(this.groups).find(function (group) {
      return group.permissions && group.permissions.template;
    });

    if (!someGroup) return;

    const typeRegex = this.getTypeFilterRegex();
    const basicPermissions = _.chain(someGroup.permissions.template)
      .map(function (value, index) {
        return {
          name: index,
          tag: 'tool.restrictions.template.permission.' + index
        };
      })
      .filter(function (field) {
        return this.basicHide.indexOf(field.name) < 0;
      }, this)
      .filter(function (field) {
        return field.name.match(typeRegex);
      }).value();

    const maxMargin = this.getMaxMargin();
    const excludedRestrictions = [`${this.type}_opacity`, `${this.type}_z_index`, `${this.type}_stroke`, 'vector-replace', 'icon_replace'];
    this.$el.html(this.template({
      basic: this.sortElementPermissions(this.type, basicPermissions).filter((p) => !excludedRestrictions.includes(p.name)),
      max_margin: maxMargin,
      is_vector: this.selection.is_vector,
      is_shape: this.selection.type === 'shape'
    }));

    this.initColorsList();
    this.initLibraryColors();
    this.initSourceList();
    await this.initLibraryFolders(this.type);
    this.initSlider(maxMargin);
    this.renderRestrictions();
    this.renderDisabled();
    this.initAddButton();
  },

  remove: function () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  renderDisabled: function () {
    this._renderImageDisabled();
    this._renderPositionDisabled();
  },

  _renderRestrictions: function (restrictions, sectionName) {
    BaseView.prototype._renderRestrictions.apply(this, arguments);

    if (sectionName === 'colors' && restrictions[sectionName]) {
      _(restrictions[sectionName].list).each(this.colorsListView.addElement);
    } else if (sectionName === 'colors-library' && restrictions[sectionName]) {
      this.colorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    } else if (sectionName === 'margin' && restrictions.margin) {
      this.marginSlider.slider('value', restrictions.margin.size);
      this.setMarginUI(restrictions.margin.size);
    } else if (sectionName === 'movement' && restrictions.movement) {
      this.renderMovementRestrictions(restrictions);
    }

    if (sectionName === 'source' && restrictions[sectionName] && restrictions[sectionName].list) {
      _(restrictions[sectionName].list).each(this.logosListView.addElement);
      setTimeout(() => this.selectSpecifySource(), 150);
    }

    if (sectionName === 'folder' && restrictions.source && restrictions.source.library_folder) {
      setTimeout(() => this.selectSpecifyFolder(), 150);
    }
  },

  _renderImageDisabled: function () {
    const replaceImageInput = this.el.querySelector('.element-restriction-options label.switch input[type="checkbox"]');
    const replaceImageSubInput = this.el.querySelector('.element-restriction-sub-options label.switch input[type="radio"]');
    const isReplaceOn = this.getOptionValue($(replaceImageInput));
    const isReplaceSpecifiedOn = this.getOptionValue($(replaceImageSubInput));
    replaceImageInput && this.el.querySelector('div[data-name="source"]')?.classList.toggle('hidden', !isReplaceOn);
    replaceImageInput && this.el.querySelector('div[data-name="folder"]')?.classList.toggle('hidden', !isReplaceOn);
    replaceImageInput && replaceImageSubInput && this.$el.find(`.${this.type}-replacement-options`).toggleClass('hidden', !(isReplaceOn && isReplaceSpecifiedOn));
    replaceImageInput && replaceImageSubInput && this.$el.find(`.${this.type}-replacement-folders`).toggleClass('hidden', !(isReplaceOn && isReplaceSpecifiedOn));
    this.recalculateSectionHeight(replaceImageInput);
  },

  _renderPositionDisabled: function () {
    const replacePositionInput = document.querySelector(`#element-restrictions-${this.type}-position`);
    const replaceMarginSubInput = document.querySelector('#element-restrictions-margin');
    const replaceMovementSubInput = document.querySelector('#element-restrictions-movement');
    const isReplaceOn = this.getOptionValue($(replacePositionInput));
    const isReplaceMarginOn = this.getOptionValue($(replaceMarginSubInput));
    const isReplaceMovementOn = this.getOptionValue($(replaceMovementSubInput));

    if (replacePositionInput) {
      this.$el.find('div[data-name="margin"] .element-restriction-sub-options').parent().toggleClass('hidden', !isReplaceOn);
      this.$el.find('div[data-name="movement"] .element-restriction-sub-options').parent().toggleClass('hidden', !isReplaceOn);

      if (replaceMarginSubInput) {
        this.$el.find('.margin-replacement-options').toggleClass('hidden', !(isReplaceOn && isReplaceMarginOn));
      }

      if (replaceMovementSubInput) {
        this.$el.find('.movement-replacement-options').toggleClass('hidden', !(isReplaceOn && isReplaceMovementOn));
      }

      this.recalculateSectionHeight(replacePositionInput);
    }
  },

  initSlider: function (maxMargin) {
    const $slider = this.$el.find('.restrictions[data-name="margin"] .slider');

    this.marginSlider = $slider.slider({
      max: maxMargin,
      min: 0,
      value: 0
    });
  },

  initSourceList: function () {
    this.logosListView && this.logosListView.remove();
    this.logosListView = new this.ElementListView({
      el: this.$el.find(`.${this.type}-replacement-options li`),
      type: this.type
    });

    this.logosListView.on('change', _.bind(function () {
      const $input = this.logosListView.$el.find('input');

      this.persistOptionRestriction($input);
    }, this));

    this.logosListView.on('apply', _.bind(function (data) {
      DesignFacade.set(this.selection.id, data);
    }, this));
  },

  getTypeFilterRegex: function () {
    return /^logo_/;
  },

  getMaxMargin: function () {
    const maxMargin = this.canvas.contentW < this.canvas.contentH
      ? this.canvas.contentW / 8
      : this.canvas.contentH / 8;

    return Math.round(maxMargin);
  },

  renderMovementRestrictions: function (restrictions) {
    if (!restrictions.movement) return;

    const filter = restrictions.movement;

    for (const [key, value] of Object.entries(filter)) {
      this.el.querySelector('.movement-replacement-options .options li input[name="' + key + '"]').checked = value;
    }
  },

  updateImageRestrictions: async function (data) {
    const ePermissions = await RestrictionsFactory.getElementPermissions();
    const permission = ePermissions.find(permission => {
      return permission.page_number === INKIVE.Tool._current_page_number &&
        permission.element_id === this.selection.id;
    });
    const restrictions = permission ? JSON.parse(permission.restrictions) : {};

    if (restrictions.source && restrictions.source.list) {
      if (!restrictions.source.list.find((data) => { return data.thumb_src === data.tempLink; })) {
        INKIVE.Tool.getInstance().editor.canvas.call('advice.show', 'source-restriction-applied');
        restrictions.source.list.push({
          thumb_src: data.tempLink,
          is_vector: name.includes('.svg')
        });

        RestrictionsFactory.setGlobalElementRestriction(
          this.selection.id, JSON.stringify(restrictions)
        );
      }

      for (const source of restrictions.source.list) {
        !this.logosListView.data.find((data) => { return data.thumb_src === source.thumb_src; }) &&
          this.logosListView.addElement(source);
      }
    }

    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
    this.initAddButton();
  },

  initAddButton: function () {
    const addButton = this.el.querySelector('.replacement-options ul.options li .thumbnails-wrapper .add-new');

    const opts = {
      restrictions: {
        allowedFileTypes: ['image/svg+xml', 'image/png', 'image/jpeg']
      },
      onFileUploaded: this.updateImageRestrictions.bind(this)
    };

    this.uppyFactory = new UppyFactory({
      id: `uppy-library-${this.type}`,
      button: addButton,
      loadtype: this.type,
      restrictions: opts.restrictions,
      onFileUploaded: opts.onFileUploaded
    });

    this.uppyFactory.initUppyManager();
  }
});
